import { SendToHeadDetectionResponse } from '@common/web-worker/services';
import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import { createAction } from '@reduxjs/toolkit';
import { markWorkerAction } from '@utils';
import { TDOId } from '../universal/models/Brands';
import { GlobalSettings } from '../mediaDetails/models';

interface CREATE_JOB_FACES_VARIABLES {
  id: TDOId;
  tdoName: string;
}

export type CreateJobFacesActionType = Pick<
  GlobalSettings,
  'videoType' | 'faceDetectionThreshold'
>;

export const CREATE_JOB_FACES = 'request to create job for heads';
export const CREATE_JOB_FACES_SUCCESS =
  createGraphQLSuccessAction<SendToHeadDetectionResponse>(
    'create job for heads successfully'
  );
export const CREATE_JOB_FACES_FAILURE = createGraphQLFailureAction<
  any,
  CREATE_JOB_FACES_VARIABLES,
  true
>('create job for heads failed');
export const CREATE_JOB_FACES_ACTION = createAction<
  CreateJobFacesActionType | undefined
>('heads/create-job');
export const actionSendToHeadDetection = (payload?: CreateJobFacesActionType) =>
  markWorkerAction(CREATE_JOB_FACES_ACTION(payload));

export const ON_CHANGE_DETECT_OBJECTS = createAction<{
  name: string;
  value: boolean;
}>('on change detect objects');
export const actionOnChangeDetectObjects = (name: string, value: boolean) =>
  ON_CHANGE_DETECT_OBJECTS({ name, value });
export const SHOW_DETECT_OPTIONS_DIALOG = createAction<{
  value: boolean;
}>('show detect options dialog');
export const actionShowDetectOptionsDialog = (value: boolean) =>
  SHOW_DETECT_OPTIONS_DIALOG({ value });
export const DETECT_OPTIONS = {
  HEAD_OBJECTS: 'headObjects',
  PERSON_OBJECTS: 'personObjects',
};

export const DELETE_OBJECT_DETECTION_RESULTS = createAction<{
  onlyUserEdited?: boolean;
}>('delete object detection results');
export const actionDeleteObjectDetectionResults = (payload: {
  onlyUserEdited?: boolean;
}) =>
  markWorkerAction(
    DELETE_OBJECT_DETECTION_RESULTS({ onlyUserEdited: payload?.onlyUserEdited })
  );
export const DELETE_OBJECT_DETECTION_RESULTS_SUCCESS =
  'delete object detection results success';
export const DELETE_OBJECT_DETECTION_RESULTS_FAILURE =
  'delete object detection results failure';
